import * as tslib_1 from "tslib";
import { AfterViewInit, EventEmitter, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LayerApi } from '../../../api/layer-api';
import { environment } from '../../../environment';
import { AoiService } from '../../../services/aoi.service';
import { GisToolsService } from '../../../services/gis-tools.service';
import { MapService } from '../../../services/map.service';
import { BaseComponent } from '../../base.component';
var IIntersectionResult = /** @class */ (function () {
    function IIntersectionResult() {
    }
    return IIntersectionResult;
}());
export { IIntersectionResult };
var IntersectionComponent = /** @class */ (function (_super) {
    tslib_1.__extends(IntersectionComponent, _super);
    function IntersectionComponent(_vcr, aoiService, layerApi, mapService, gisToolsService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.aoiService = aoiService;
        _this.layerApi = layerApi;
        _this.mapService = mapService;
        _this.gisToolsService = gisToolsService;
        _this.debounceTimer = 1000;
        _this.hasSelectionChange = new EventEmitter();
        _this.error = false;
        _this.searchText = '';
        _this.searchUpdated = new Subject();
        _this.searchComplete = false;
        _this.intersectionLayerId = null;
        _this.activate = function () {
            _this.hasSelectionChange.emit(!!_this.selectResult);
            if (_this.isActive) {
                return;
            }
            _this.search();
            _this.isActive = true;
        };
        _this.reset = function () {
            _this.searchText = '';
            _this.clearSelectedResult();
            _this.clearResults();
        };
        _this.addResultToMap = function () {
            var searchCriteria = {
                type: 'intersection',
                title: _this.selectedResult.streetName1 + "  " + _this.selectedResult.streetName2,
                layerId: _this.intersectionLayerId,
                query: {
                    operator: 'AND',
                    subqueries: [
                        { field: 'node_id', operator: '=', value: _this.selectedResult.nodeId },
                        { field: 'cty_code', operator: '=', value: _this.selectedResult.county }
                    ]
                }
            };
            _this.aoiService.setSearchCriterias([searchCriteria]);
        };
        _this.searchUpdated
            .pipe(debounceTime(_this.debounceTimer), distinctUntilChanged())
            .subscribe(function () {
            _this.search();
        });
        var environmentLayerSettings = environment.layers.filter(function (x) { return x.name === 'intersection'; })[0];
        _this.intersectionLayerId = environmentLayerSettings.id;
        return _this;
    }
    Object.defineProperty(IntersectionComponent.prototype, "selectedResult", {
        get: function () {
            return this._selectedResult;
        },
        set: function (value) {
            this._selectedResult = value;
            this.hasSelectionChange.emit(!!value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IntersectionComponent.prototype, "county", {
        get: function () {
            return this._county;
        },
        set: function (county) {
            this._county = county;
            this.filterByCounty();
        },
        enumerable: true,
        configurable: true
    });
    IntersectionComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this;
                        if (!this.mapViewRef) return [3 /*break*/, 1];
                        _b = this.mapViewRef;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 2:
                        _b = _d.sent();
                        _d.label = 3;
                    case 3:
                        _a.mapViewRef = _b;
                        this.mapService.mcMapView = this.mapViewRef;
                        _c = this;
                        return [4 /*yield*/, this.gisToolsService.getAllCounties('countyCode, name')];
                    case 4:
                        _c.counties = _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IntersectionComponent.prototype.clearSelectedResult = function () {
        this.selectedResult = null;
    };
    IntersectionComponent.prototype.getValidStreetArrayFromSearchText = function () {
        if (this.searchText.length > 0) {
            var streets = this.searchText.toUpperCase().split(' AND ');
            var streetCount = 2;
            if (streets.length === streetCount && streets[0].length && streets[1].length) {
                {
                    return streets;
                }
            }
        }
        return null;
    };
    IntersectionComponent.prototype.onTextboxChange = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.searchUpdated.next(this.searchText);
                return [2 /*return*/];
            });
        });
    };
    IntersectionComponent.prototype.search = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var streets;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.searchComplete = false;
                        this.loading = false;
                        this.error = false;
                        streets = this.getValidStreetArrayFromSearchText();
                        if (!streets) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.retrieveResults()];
                    case 1:
                        _a.sent();
                        this.searchComplete = true;
                        return [3 /*break*/, 3];
                    case 2:
                        this.clearResults();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    IntersectionComponent.prototype.retrieveResults = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var textForThisSearch, streets, fieldNames, query, data_1, countyIndex_1, stateRouteIndex_1, streetName1Index_1, streetName2Index_1, nodeIdIndex_1, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        this.selectedResult = null;
                        this.results = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        textForThisSearch = this.searchText;
                        streets = this.getValidStreetArrayFromSearchText();
                        fieldNames = ['cty_code,st_rt_no,street_name,street_name_ixn,node_id'];
                        query = {
                            operator: 'OR',
                            subqueries: [
                                {
                                    operator: 'AND',
                                    subqueries: [
                                        { operator: 'LIKE', field: 'street_name', value: streets[0] },
                                        { operator: 'LIKE', field: 'street_name_ixn', value: streets[1] }
                                    ]
                                },
                                {
                                    operator: 'AND',
                                    subqueries: [
                                        { operator: 'LIKE', field: 'street_name', value: streets[1] },
                                        { operator: 'LIKE', field: 'street_name_ixn', value: streets[0] }
                                    ]
                                }
                            ]
                        };
                        return [4 /*yield*/, this.layerApi.getData(this.intersectionLayerId, fieldNames, query)];
                    case 2:
                        data_1 = _b.sent();
                        if (textForThisSearch === this.searchText) {
                            countyIndex_1 = 0, stateRouteIndex_1 = 1, streetName1Index_1 = 2, streetName2Index_1 = 3, nodeIdIndex_1 = 4;
                            this.results = data_1.map(function (x) {
                                var displayName = '';
                                var nodeIdDuplicateCount = data_1.filter(function (ixn) { return ixn[nodeIdIndex_1] === x[nodeIdIndex_1]; }).length;
                                if (nodeIdDuplicateCount > 1) {
                                    displayName = x[streetName1Index_1] + " AND " + x[streetName2Index_1] + " (" + nodeIdDuplicateCount + ")";
                                }
                                else {
                                    displayName = x[streetName1Index_1] + " AND " + x[streetName2Index_1];
                                }
                                return {
                                    county: x[countyIndex_1],
                                    stateRoute: x[stateRouteIndex_1],
                                    streetName1: x[streetName1Index_1],
                                    streetName2: x[streetName2Index_1],
                                    nodeId: x[nodeIdIndex_1],
                                    displayName: displayName
                                };
                            }).reduce(function (arr, curr) {
                                var existingIntersection = arr.find(function (intersection) { return intersection.nodeId === curr.nodeId; });
                                if (existingIntersection) {
                                    if (!existingIntersection.stateRoute.includes(curr.stateRoute)) {
                                        // Append the missing route number
                                        existingIntersection.stateRoute += ", " + curr.stateRoute;
                                    }
                                    // else leave it out as a duplicate
                                }
                                else {
                                    arr.push(curr);
                                }
                                return arr;
                            }, []);
                            this.unfilteredResults = this.results;
                            this.loading = false;
                        }
                        if (this.county) {
                            this.filterByCounty();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        this.loading = false;
                        this.error = true;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IntersectionComponent.prototype.selectResult = function (result) {
        this.selectedResult = result;
        var searchCriteria = {
            type: 'intersection',
            title: this.selectedResult.streetName1 + " " + this.selectedResult.streetName2
        };
        this.aoiService.setSearchCriterias([searchCriteria]);
    };
    IntersectionComponent.prototype.clearResults = function () {
        this.searchComplete = false;
        this.selectedResult = null;
        this.results = [];
    };
    IntersectionComponent.prototype.filterByCounty = function () {
        var _this = this;
        if (this.unfilteredResults.length) {
            this.results = this.county !== '' ? this.unfilteredResults.filter(function (intersection) { return intersection.county === _this.county.countyCode; }) : this.unfilteredResults;
        }
    };
    return IntersectionComponent;
}(BaseComponent));
export { IntersectionComponent };
